import LegalLayout from "./LegalLayout";
import ComingSoon from "./ComingSoon";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" kicker="Legal">
      <ComingSoon
        blurb="We're finalising our privacy policy — including how we handle your body data, photos, and closet under India's DPDP Act."
        testid="legal-privacy-coming-soon"
      />
    </LegalLayout>
  );
}
